module.exports = __webpack_public_path__ + "img/banner-3.bae550cb.jpg";